exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-calendar-monthly .v-chip,.v-chip .v-chip__content{border-radius:28px 5px 5px 28px}", "", {"version":3,"sources":["/opt/build/repo/src/components/calendar/TeamView.vue"],"names":[],"mappings":"AACA,qDACE,+BAAiC,CAClC","file":"TeamView.vue","sourcesContent":["\n.v-calendar-monthly .v-chip, .v-chip .v-chip__content {\n  border-radius: 28px 5px 5px 28px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21b1ed38","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/TeamView.vue
// module id = 1606
// module chunks = 3